<template>
  <div style="margin: 20px 10px;">
    <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        border
    >
      <el-table-column prop="pay_id" label="支付记录编码"/>
      <el-table-column prop="pay_amount" label="支付金额"/>
      <el-table-column prop="pay_type" label="支付渠道"/>
      <el-table-column prop="pay_time" label="支付时间"/>
    </el-table>

    <pagination
        v-show="total>0"
        :total="total"
        :page.sync="page"
        :limit.sync="pageSize"
        @pagination="fetchData"
    />

  </div>
</template>

<script>
import api from "@/requset/api";

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    refresh() {
      this.fetchData()
    },
    fetchData() {
      this.loading = true
      api.pay_list({
        page: this.page,
        pageSize: this.pageSize
      })
          .then((res) => {
            this.loading = false;
            if (res.data.error_code != 0) {
              this.$message({
                message: res.data.message,
                type: "warning",
              });
              return
            }
            this.tableData = res.data.data.list
            this.total = res.data.data.total
          })
          .catch(() => {
            this.loading = false;
          });
    },
  }
}
</script>
